import axios from "axios";


const BUSAPI_BASE_URL = process.env.REACT_APP_BusAPI_BASE_URL;


export const getAutoBusCities = async (query = "") => {
    //console.log("Calling API:", `${BUSAPI_BASE_URL}/api/Bus/Cities`);
  try {
    const { data } = await axios.get(
      `${BUSAPI_BASE_URL}/api/Bus/Cities`,
      {
        params: { query }
      }
    );
    return data;
  } catch (error) {
    console.error("Error fetching city suggestions:", error);
    throw error;
  }
};


export const BusSearchResults = async (requestBody) => {
  try {
    if (!BUSAPI_BASE_URL) {
      throw new Error("Bus API Base URL is not defined");
    }

    const url = `${BUSAPI_BASE_URL}/api/Bus/SearchBuses`;

    //console.log("API URL:", url);
    //console.log("Request Payload:", requestBody);

    const response = await axios.post(url, requestBody, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      timeout: 30000,
    });

    //  Validate response structure
    if (!response || !response.data) {
      throw new Error("Invalid API response");
    }

    //console.log(" API Success:", response.data);

    return response.data;

  } catch (error) {

    // ✅ API responded with error (400, 500 etc.)
    if (error.response) {
      const apiError = error.response.data;

      console.error("❌ API Error:", apiError);

      throw {
        message: apiError?.error?.desc || "API Error",
        code: apiError?.error?.code || error.response.status,
        full: apiError,
      };
    }

    // ❌ No response (timeout / network)
    if (error.request) {
      console.error("❌ No response from server:", error.request);

      throw {
        message: "Server not responding. Please try again.",
        code: "NO_RESPONSE",
      };
    }

    // ❌ Other errors
    console.error("❌ Error:", error.message);

    throw {
      message: error.message || "Something went wrong",
      code: "UNKNOWN",
    };
  }
};



export const RetrieveTripSelected = async (referenceNo,key) => {
  //console.log("REFERENCE NO FROM URL:", referenceNo);
  try {
   
    const response = await axios.get(
  `${BUSAPI_BASE_URL}/api/Bus/RetrieveSelectedTrip`,
  {
    params: {
      referenceNo :referenceNo,
      key: key,
      clientCode: "BerryJourneys" // optional
    }
  }
);

    //console.log("API RESPONSE:", response.data);

    return response.data; //  IMPORTANT
  } catch (error) {
    console.error("Error fetching Retrive Selected Trip:", error);
    throw error;
  }
};


export const BusSeatLayout = async (requestBody) => {
  //console.log("BusSeatLayout", requestBody);
  try {
    const response = await axios.post(
      `${BUSAPI_BASE_URL}/api/Bus/SeatLayout`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("Seat Layout result:", response)
    return response.data;
  } catch (error) {
    console.error("Seat Layout --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const SaveSelectedTrip = async (requestBody) => {
  //console.log("SaveSelectedTrip", requestBody);
  try {
    const response = await axios.post(
      `${BUSAPI_BASE_URL}/api/Bus/SaveSelectedTrip`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("Save Selected Trip:", response)
    return response.data;
  } catch (error) {
    console.error("Save Selected Tript --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const BlockSeats = async (requestBody) => {
  //console.log("BlockSeats Request:", requestBody);
  try {
    const response = await axios.post(
      `${BUSAPI_BASE_URL}/api/Bus/BlockSeats`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    //console.log("BlockSeats Response:", response.data);
    return response.data;

  } catch (error) {
    console.error(
      "BlockSeats Error:",
      error.response?.data || error.message
    );
    throw error.response?.data || error.message;
  }
};

export const BusBookingService = async (requestBody) => {
  //console.log("BusBookingService Request:", requestBody);

  try {
    const response = await axios.post(
      `${BUSAPI_BASE_URL}/api/Bus/BookBus`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("Booking Response:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Booking Error:",
      error.response?.data || error.message
    );
    throw error.response?.data || error.message;
  }
};

export const GetBusTransactionDetails = async (requestBody) => {
  //console.log("Transaction Details Request:", requestBody);

  try {
    const { data } = await axios.post(
      `${BUSAPI_BASE_URL}/api/Bus/GetTransactionDetails`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    //console.log("Transaction Details Response:", data);
    return data;

  } catch (error) {
    const errorMessage =
      error?.response?.data || error?.message || "Something went wrong";

    console.error("Transaction Details Error:", errorMessage);

    throw errorMessage;
  }
};



export const SendBusBookingNotifications = async (requestBody) => {
  //console.log("requestBody", requestBody);
  try {
    const response = await axios.post(
      //`${FlightAPI_BASE_URL}/api/Utility/SendFlightBookingNotifications`,
      `${BUSAPI_BASE_URL}/api/Utility/SendBusBookingNotifications`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("SendBusBookingNotifications --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("SendBusBookingNotifications --> error:", error.response?.data || error.message);
    throw error;
  }
};


export const PreCancellation = async (requestBody) => {
  //console.log("requestBody", requestBody);
  try {
    const response = await axios.post(
      `${BUSAPI_BASE_URL}/api/Bus/PreCancellation`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("PreCancellation --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("PreCancellation --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const BookingCancellation = async (requestBody) => {
  //console.log("requestBody", requestBody);
  try {
    const response = await axios.post(
      `${BUSAPI_BASE_URL}/api/Bus/CancelBookedTickets`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //console.log("BookingCancellation --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("BookingCancellation --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const TicketDownload = async (requestBody) => {
  //console.log("requestBody", requestBody);
  try {
    const response = await axios.get(
      `${BUSAPI_BASE_URL}/api/Utility/GenerateETicket`,
      {
        params: {
          referenceNo: requestBody.referenceNo,
          type: requestBody.type
        },
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching agency details:", error);
    throw error.response?.data || error;
  }
};
